import { Box, Paper, useTheme } from "@mui/material";
import { BORDER_RADIUS } from "../../../../utils/constants";

const ChatMessageBubble = ({ message, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: message.role === "user" ? "flex-end" : "flex-start",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: "85%",
          px: 2,
          py: 1.5,
          borderRadius: `${BORDER_RADIUS * 4}px`,
          ...(message.role === "user"
            ? {
                background: theme.palette.button.primary.main,
                color: theme.palette.button.primary.contrastText,
              }
            : {
                backgroundColor: "action.hover",
                color: "text.primary",
              }),
          border:
            message.role === "assistant" && !message.isThinking
              ? `1px solid ${theme.palette.divider}`
              : "none",
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};

export default ChatMessageBubble;
